import {BaseModel} from "@/model/Model";
import User from "@/model/User";
import Book from "@/model/Book";
import CompanyLocation from "@/model/CompanyLocation";
import CompanyBookRental from "@/model/CompanyBookRental";

export default class CompanyBook extends BaseModel<CompanyBook> {
    book: Book = new Book()

    number!: number
    remainedNumber!: number

    rentalable!: boolean
    rentals!: Array<CompanyBookRental>

    companyLocation = new CompanyLocation()
}

export class CompanyBookDetail extends CompanyBook {

}
